// US state name -> USPS abbreviation, for compact state cards.
export const STATE_ABBR = {
  Alabama: "AL", Alaska: "AK", Arizona: "AZ", Arkansas: "AR", California: "CA",
  Colorado: "CO", Connecticut: "CT", Delaware: "DE", Florida: "FL", Georgia: "GA",
  Hawaii: "HI", Idaho: "ID", Illinois: "IL", Indiana: "IN", Iowa: "IA", Kansas: "KS",
  Kentucky: "KY", Louisiana: "LA", Maine: "ME", Maryland: "MD", Massachusetts: "MA",
  Michigan: "MI", Minnesota: "MN", Mississippi: "MS", Missouri: "MO", Montana: "MT",
  Nebraska: "NE", Nevada: "NV", "New Hampshire": "NH", "New Jersey": "NJ",
  "New Mexico": "NM", "New York": "NY", "North Carolina": "NC", "North Dakota": "ND",
  Ohio: "OH", Oklahoma: "OK", Oregon: "OR", Pennsylvania: "PA", "Rhode Island": "RI",
  "South Carolina": "SC", "South Dakota": "SD", Tennessee: "TN", Texas: "TX",
  Utah: "UT", Vermont: "VT", Virginia: "VA", Washington: "WA", "West Virginia": "WV",
  Wisconsin: "WI", Wyoming: "WY",
};

// Draw-system -> pill styling
export const SYSTEM_STYLES = {
  preference_point: "bg-[#2E5A3E]/12 text-[#2E5A3E]",
  bonus_point: "bg-[#8A5A44]/15 text-[#8A5A44]",
  random_raffle: "bg-[#3B5B8C]/12 text-[#3B5B8C]",
  hybrid: "bg-[#6A4E8A]/12 text-[#6A4E8A]",
  otc_general: "bg-[#5C6B61]/12 text-[#5C6B61]",
};

// competition-trend -> dot color + text
export const TREND_STYLES = {
  rising_fast: { dot: "bg-[#B04A3A]", text: "text-[#B04A3A]" },
  rising: { dot: "bg-[#D98A3D]", text: "text-[#B7761F]" },
  stable: { dot: "bg-[#2E7D46]", text: "text-[#2E7D46]" },
  no_points: { dot: "bg-[#3B5B8C]", text: "text-[#3B5B8C]" },
  unknown: { dot: "bg-[#9A958B]", text: "text-[#5C6B61]" },
};

// Custom generated species emblem icons (blaze-orange line art, transparent bg).
const B = "https://static.prod-images.emergentagent.com/jobs/98d31929-0a65-48ad-9c33-4d117fb8b00d/images";
export const SPECIES_ICON = {
  Elk: `${B}/5dfbea727a77b439a7d7d41b402e29e368a847ce13185422aac054b8bd68e0c9.jpeg`,
  "Mule Deer": `${B}/ea3e02c47c7ff5af5c4406df6c99378a263f0667787e88d5bb40c3e7cb365d8a.jpeg`,
  "Whitetail Deer": `${B}/8bbe3179823c408974596e39a0c64c3b3d8e9f1062a9cd6455301bb44accfa14.jpeg`,
  Pronghorn: `${B}/929a53ab59045208e2e7d5e8394b64a8e0ec823618060fcd8fa1393229f3ef57.jpeg`,
  Moose: `${B}/545478cf462f4f34ab2fb9ac7d3d879c78a655441e3d3e017e2eec9f4442cc6d.jpeg`,
  "Black Bear": `${B}/24ac05fd87ff6957945b95987649b4b369fd49fc7697df49a4ec4abb03c025f9.jpeg`,
  "Wild Sheep": `${B}/778bef560f97371b705399092aa4bb8cd4049f932d57166243fc79d95d7c8d48.jpeg`,
  "Mountain Goat": `${B}/79c3fe103c0e057d24ed7a969a8c113e47ccb7eda310221f6ce8963d0bb1624d.jpeg`,
  Bison: `${B}/4af738fa23f79bde00c9ebb3336c6910b3b8942d4eb7bc8240e8f4c686a801e1.jpeg`,
  "Wild Turkey": `${B}/ea2bc0364688bc7e6431da26b4e59550a0d4e2016de4374245283b9b2d7c9b8a.jpeg`,
};

// Premium photographic wildlife imagery for the species rail (Unsplash).
const U = "https://images.unsplash.com/";
const UP = "?crop=entropy&cs=srgb&fm=jpg&q=80&w=500&fit=crop";
export const SPECIES_PHOTO = {
  Elk: `${U}photo-1777857426867-e63aea59b330${UP}`,
  "Mule Deer": `${U}photo-1476922027627-aa7293e3aaa8${UP}`,
  "Whitetail Deer": `${U}photo-1484406566174-9da000fda645${UP}`,
  Pronghorn: `${U}photo-1622909988979-b591dbe146f1${UP}`,
  "Black Bear": `${U}photo-1698985371134-3c21d56336e5${UP}`,
  "Mountain Lion": `${U}photo-1527720255604-b27935ade401${UP}`,
  "Wild Turkey": `${U}photo-1543069422-15ebb2128804${UP}`,
  Moose: `${U}photo-1640322815494-5feb426f8074${UP}`,
  "Wild Sheep": `${U}photo-1517217759187-c28c5cbb51e3${UP}`,
  "Mountain Goat": `${U}photo-1588466585717-f8041aec7875${UP}`,
  Bison: `${U}photo-1740246309269-811fa487a546${UP}`,
};
export const SPECIES_PHOTO_FALLBACK = `${U}photo-1509316785289-025f5b846b35${UP}`;

// Per-state cinematic hero landscapes. Falls back to STATE_HERO_DEFAULT.
export const STATE_HERO_DEFAULT = "https://static.prod-images.emergentagent.com/jobs/98d31929-0a65-48ad-9c33-4d117fb8b00d/images/c81f24ff97726b866b791896b2e9ece2b2e7fbb5fb7eb9d90965c5107442b838.jpeg";
const UH = "?crop=entropy&cs=srgb&fm=jpg&q=80&w=1100&fit=crop";
const h = (id) => `${U}photo-${id}${UH}`;
export const STATE_HERO = {
  // Montana intentionally omitted — uses STATE_HERO_DEFAULT (a Montana valley).
  Alabama: h("1606337576673-b799f3ce8f7b"),
  Alaska: h("1534797213442-36cc35500749"),
  Arizona: h("1509316785289-025f5b846b35"),
  Arkansas: h("1707707366496-c593b63dfda2"),
  California: h("1532501854787-31ce43c2b281"),
  Colorado: h("1581552936330-f8eb487334e6"),
  Connecticut: h("1664867825824-71ef9ab987e4"),
  Delaware: h("1560178290-43a055ae5106"),
  Florida: h("1770672850748-8f71736bbfc9"),
  Georgia: h("1605473157430-a8c3ac62aa88"),
  Hawaii: h("1477808321888-2a35497d1ade"),
  Idaho: h("1452665675484-a3ccee1e3330"),
  Illinois: h("1572983934893-757c2c4b4217"),
  Indiana: h("1743356143946-170a4fc2daa6"),
  Iowa: h("1645911078446-33a88e179a96"),
  Kansas: h("1590433136906-733e707e7f25"),
  Kentucky: h("1528735001879-5feffc146904"),
  Louisiana: h("1597179875074-b681f2169be0"),
  Maine: h("1693307481261-1725dbe5a61f"),
  Maryland: h("1600275128492-ecf0c8d94455"),
  Massachusetts: h("1603395728893-bce27617f8b3"),
  Michigan: h("1586734184600-84392aff3ef6"),
  Minnesota: h("1550594427-417e0a74911f"),
  Mississippi: h("1730158844272-c34247e1fa9a"),
  Missouri: h("1606972192702-8b1fcf170348"),
  Nebraska: h("1581360050420-119e24ff2f71"),
  Nevada: h("1516325759459-7251ff998ab8"),
  "New Hampshire": h("1666785170709-e7c9a10892c2"),
  "New Jersey": h("1601071354388-97c0e36db65e"),
  "New Mexico": h("1650129103675-e88a7d24e54a"),
  "New York": h("1688666199639-27615b810017"),
  "North Carolina": h("1574079630059-3b6cc5834483"),
  "North Dakota": h("1596112849272-c416ef63d53f"),
  Ohio: h("1629664315178-b81a6b24c2df"),
  Oklahoma: h("1608240525233-7c6e1657c494"),
  Oregon: h("1750045850708-8e650d8ab71d"),
  Pennsylvania: h("1643769764410-4f9d0a3f3a9b"),
  "Rhode Island": h("1727786534508-0b17069f0c9c"),
  "South Carolina": h("1647534849919-ede2de56dc39"),
  "South Dakota": h("1688656116039-03691a142979"),
  Tennessee: h("1587579104732-0799598b0111"),
  Texas: h("1667857391846-664027bd32e7"),
  Utah: h("1649113103373-ff47816ae721"),
  Vermont: h("1664867834962-f6edf47f1f2c"),
  Virginia: h("1574882999204-99b6b00a9ce1"),
  Washington: h("1586652495990-ba28dee51af0"),
  "West Virginia": h("1696265724182-ea83f25510ae"),
  Wisconsin: h("1698027776637-cceba7b0297f"),
  Wyoming: h("1689445246150-e6467834a27a"),
};

// Curated huntable-species lists per state (public agency information — NOT statistics).
// Drives the "Explore <State> by species" rail. States not listed fall back to
// species that have verified draw data.
export const STATE_SPECIES = {
  Montana: ["Elk", "Mule Deer", "Whitetail Deer", "Pronghorn", "Black Bear", "Mountain Lion", "Wild Turkey", "Moose", "Wild Sheep", "Mountain Goat"],
  Colorado: ["Elk", "Mule Deer", "Pronghorn", "Black Bear", "Mountain Lion", "Moose", "Wild Sheep", "Mountain Goat", "Wild Turkey"],
  Wyoming: ["Elk", "Mule Deer", "Whitetail Deer", "Pronghorn", "Black Bear", "Mountain Lion", "Moose", "Wild Sheep", "Mountain Goat", "Bison", "Wild Turkey"],
  Oregon: ["Elk", "Mule Deer", "Pronghorn", "Black Bear", "Mountain Lion", "Wild Sheep", "Mountain Goat", "Wild Turkey"],
  Utah: ["Elk", "Mule Deer", "Pronghorn", "Black Bear", "Mountain Lion", "Moose", "Wild Sheep", "Mountain Goat", "Bison", "Wild Turkey"],
  Arizona: ["Elk", "Mule Deer", "Whitetail Deer", "Pronghorn", "Black Bear", "Mountain Lion", "Wild Sheep", "Bison", "Wild Turkey"],
  Nevada: ["Mule Deer", "Elk", "Pronghorn", "Black Bear", "Mountain Lion", "Wild Sheep", "Mountain Goat", "Wild Turkey"],
  Washington: ["Elk", "Mule Deer", "Whitetail Deer", "Black Bear", "Mountain Lion", "Moose", "Wild Sheep", "Mountain Goat", "Wild Turkey"],
  "New Mexico": ["Elk", "Mule Deer", "Pronghorn", "Black Bear", "Mountain Lion", "Wild Sheep", "Bison", "Wild Turkey"],
  Idaho: ["Elk", "Mule Deer", "Whitetail Deer", "Pronghorn", "Black Bear", "Mountain Lion", "Moose", "Wild Sheep", "Mountain Goat", "Wild Turkey"],
};

export const STATE_REGION = {
  Washington: "Pacific", Oregon: "Pacific", California: "Pacific", Hawaii: "Pacific", Alaska: "Pacific",
  Montana: "West", Idaho: "West", Wyoming: "West", Colorado: "West", Utah: "West", Nevada: "West",
  Arizona: "Southwest", "New Mexico": "Southwest", Texas: "Southwest", Oklahoma: "Southwest",
  "North Dakota": "Great Plains", "South Dakota": "Great Plains", Nebraska: "Great Plains", Kansas: "Great Plains",
  Minnesota: "Midwest", Wisconsin: "Midwest", Michigan: "Midwest", Iowa: "Midwest", Missouri: "Midwest",
  Illinois: "Midwest", Indiana: "Midwest", Ohio: "Midwest",
  Maine: "Northeast", "New Hampshire": "Northeast", Vermont: "Northeast", Massachusetts: "Northeast",
  "Rhode Island": "Northeast", Connecticut: "Northeast", "New York": "Northeast", "New Jersey": "Northeast",
  Pennsylvania: "Northeast", Delaware: "Northeast", Maryland: "Northeast", "West Virginia": "Northeast",
  Virginia: "Southeast", Kentucky: "Southeast", Tennessee: "Southeast", "North Carolina": "Southeast",
  "South Carolina": "Southeast", Georgia: "Southeast", Florida: "Southeast", Alabama: "Southeast",
  Mississippi: "Southeast", Arkansas: "Southeast", Louisiana: "Southeast",
};

export const DRAW_BADGE = {
  otc_general: { label: "OTC & Limited Draws", cls: "bg-charcoal/85 text-bone" },
  bonus_point: { label: "Bonus Points", cls: "bg-saddle text-bone" },
  preference_point: { label: "Preference Points", cls: "bg-forest text-bone" },
  random_raffle: { label: "Random Draw", cls: "bg-[#B08A3E] text-white" },
  hybrid: { label: "Hybrid Draw", cls: "bg-charcoal/70 text-bone" },
};
